/**
 *
 * Tabs
 *
 */
import React, { FunctionComponent } from 'react';
import { useLocation } from 'react-router-dom';
import clsx from 'clsx';
import { tabType } from './constants';
import { Link } from 'react-router-dom';
import fonts from 'app/assets/styles/fonts';
import colors from 'app/assets/styles/colors';
import { TabTemplate } from '../Menu/slice/types';
import { makeThemeStyle } from 'styles/makeThemeStyle';

interface ITabsPropTypes {
  tabs: TabTemplate[];
}

export const useStyles = makeThemeStyle(mTheme => ({
  tabs: {
    height: '100%',
    display: 'flex',
  },
  tabBtn: {
    height: '100%',
    fontWeight: 'normal',
    lineHeight: 'normal',
    padding: '0 12px 0 12px',
    fontSize: fonts.title,
    background: colors.white,
    color: colors.pewterGray,
    borderStyle: 'none',
    minWidth: '100px',
    textTransform: 'capitalize',
    '&:hover': {
      background: mTheme.palette.primary.light,
      cursor: 'pointer',
    },
    '&:focus': { outline: '0' },
  },
  tabBtn_Selected: {
    background: colors.bluePastel,
    color: colors.arcaneNavy,
  },
}));

export const Tabs: FunctionComponent<ITabsPropTypes> = props => {
  const { tabs } = props;
  const classes = useStyles({});
  const { pathname } = useLocation();
  if (tabs.length > 0) {
    return (
      <>
        <div className={classes.tabs}>
          {tabs.map((tab, index) => {
            switch (tab.type) {
              case tabType.normal:
                return (
                  <Link key={index} to={tab.tabs[0].path} replace={true}>
                    <button
                      className={clsx(
                        classes.tabBtn,
                        pathname.includes(tab.tabs[0].path)
                          ? classes.tabBtn_Selected
                          : '',
                      )}
                    >
                      {tab.tabs[0].name}
                    </button>
                  </Link>
                );

              default:
                return null;
            }
          })}
        </div>
      </>
    );
  }
  return null;
};

export default Tabs;
